export default "__VITE_ASSET__D1g_dtcM__"